import { Link } from 'react-router-dom'
import Container from '../common/Container'

export default function Footer() {

  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-brand-charcoal text-white">
      {/* Main Footer */}
      <Container>
        <div className="py-12">
          <div className="grid md:grid-cols-4 gap-8 mb-10">
            {/* Brand */}
            <div className="md:col-span-1">
              <h3 className="font-heading text-xl font-bold mb-4">
                Bench Bulletin
              </h3>
              <p className="text-brand-cream/70 text-sm leading-relaxed mb-4">
                The scrimmage finder and team management platform for Minnesota youth hockey managers.
              </p>
              <p className="text-brand-cream/50 text-xs">
                Scanning 200+ calendars hourly.
              </p>
            </div>

            {/* Find Scrimmages */}
            <div>
              <h4 className="font-heading font-semibold mb-4 text-brand-cream">
                Scrimmages
              </h4>
              <ul className="space-y-2.5 text-sm">
                <li>
                  <Link to="/scrimmages/bulletin" className="text-brand-cream/70 hover:text-white transition-colors">
                    Browse Open Ice
                  </Link>
                </li>
                <li>
                  <Link to="/claim-team" className="text-brand-cream/70 hover:text-white transition-colors">
                    Post Your Ice
                  </Link>
                </li>
                <li>
                  <Link to="/claim-team" className="text-brand-cream/70 hover:text-white transition-colors">
                    Claim Your Team
                  </Link>
                </li>
              </ul>
            </div>

            {/* Product */}
            <div>
              <h4 className="font-heading font-semibold mb-4 text-brand-cream">
                Product
              </h4>
              <ul className="space-y-2.5 text-sm">
                <li>
                  <a href="#how-it-works" className="text-brand-cream/70 hover:text-white transition-colors">
                    How It Works
                  </a>
                </li>
                <li>
                  <Link to="/pricing" className="text-brand-cream/70 hover:text-white transition-colors">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link to="/auth" className="text-brand-cream/70 hover:text-white transition-colors">
                    Sign In
                  </Link>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="font-heading font-semibold mb-4 text-brand-cream">
                Support
              </h4>
              <ul className="space-y-2.5 text-sm">
                <li>
                  <a href="mailto:support@benchbulletin.com" className="text-brand-cream/70 hover:text-white transition-colors">
                    support@benchbulletin.com
                  </a>
                </li>
                <li>
                  <Link to="/privacy" className="text-brand-cream/70 hover:text-white transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-brand-cream/70 hover:text-white transition-colors">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-white/10"></div>

          {/* Bottom Bar */}
          <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-sm text-brand-cream/50">
              © {currentYear} Bench Bulletin. All rights reserved.
            </div>
            <div className="text-xs text-brand-cream/40 text-center md:text-right">
              Built in Minnesota for Minnesota youth hockey.
            </div>
          </div>
        </div>
      </Container>
    </footer>
  )
}
